import React,{useEffect, useState} from 'react'

import './App.css';
import Board from './components/Board';

import { API_URL, LABERINTOS, LABERINTOS_SET } from './config/general';

import WinModal from './components/WinModal';

import Dashboard from './components/Dashboard';

function App() {
  const [appSize, setAppSize] = useState([window.innerWidth,window.innerHeight])
  const [laberintos, setLaberintos] = useState([]);
  const [jugandoLaberinto, setJugandoLaberinto] = useState(0);
  const [win, setWin] = useState(false);
  const [laberintoObjects, setLaberintoObjects] = useState([]);
  const [laberintoSet, setLaberintoSet] = useState();

  const queryParameters = new URLSearchParams(window.location.search)
  const urldeck = queryParameters.get("set")

  let laberinto_set = urldeck ? urldeck : 1;

  useEffect(()=> {

    const getLaberintos = async () => {

      try {
        let response = await fetch(`${API_URL}${LABERINTOS}/${laberinto_set}`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        
        let data = await response.json();
        setLaberintos(data);

      } catch (error) {
        // Handle the error
        console.error('Error fetching Laberintos data:', error.message);
        // You can set an error state or perform other actions as needed
      }
    };

    const getLaberintoSet = async () => {
  
      try {
        let response = await fetch(`${API_URL}${LABERINTOS_SET}/${laberinto_set}`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        
        let data = await response.json();
        setLaberintoSet(data);

      } catch (error) {
        // Handle the error
        console.error('Error fetching Laberinto set data:', error.message);
        // You can set an error state or perform other actions as needed
      }
    };

    getLaberintos();
    getLaberintoSet();

  }, [laberinto_set]);

  const handleResize = () => {
    setAppSize([window.innerWidth,window.innerHeight]);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    // Cleanup: Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleWin = () => {
    setWin(true);
  }

  const handleWinClick = () => {
    if (jugandoLaberinto < laberintos.length - 1){
      setJugandoLaberinto(jugandoLaberinto + 1);
    }
    else{
      setJugandoLaberinto(0);
    }
    setLaberintoObjects([])
    setWin(false);
  }

  const handleObjFound = (obj) => {
    setLaberintoObjects(copyOflaberintoObjects => [...laberintoObjects, obj]);
    //console.log(obj)
  }


  const appLayout = {
    display: 'flex',
    flexDirection: appSize[0] > appSize[1] ? 'row' : 'column'
  }

  return (
    <div className="App" style={ appLayout }>
      { laberintos[jugandoLaberinto] && laberintoSet ? <Board laberinto={ laberintos[jugandoLaberinto] } onWin={ handleWin } objFound={ handleObjFound } pendingMsg={ laberintoSet.faltan_objetos_mensaje } appSize={ appSize }/> : <p>Cargando...</p> }
      { win ? <WinModal buttonClick={ handleWinClick } message={ laberintoSet.ganar_mensaje } botonMessage={ laberintoSet.ganar_boton }/> : '' }
      { laberintoSet ? <Dashboard message={ laberintoSet.instrucciones } objetosTexto={ laberintoSet.objetos_dashboard_texto } laberintoObjects={ laberintoObjects } appSize={ appSize }/> : '' }
    </div>
  );
}

export default App;
